// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-block-list-placeholder{align-items:center;background:#fff;border:1px dashed #000;color:#000;display:flex;flex-direction:column;font-family:monospace;justify-content:center;max-width:1920px;padding:5% 20%;width:100%}.c-block-list-placeholder__content{background-color:#ebebeb;border:1px dashed #737373;max-height:240px;max-width:800px;overflow:scroll;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
